import { TAssetListItemProps } from 'src/components/AssetListItem';
import { TAssetType } from 'src/typings/base-types';

export function getLibraryBadgeColor(library: {
  type: TAssetType;
}): TAssetListItemProps['badgeColor'] {
  return library.type !== 'Area' ? 'secondary' : 'primary';
}
